import decode from 'jwt-decode';
import { Http, Method } from '@ux/drivers';
import { getCookie } from '@uds/cookies';
import { AddToBasket } from 'core/basket';
import makeDriver from 'infrastructure/drivers/json';
import { getLanguageCookie } from 'domain/selectors/common';

import createBasket from './createBasket';

type CookieDecoded =
  | {
      basketId: string;
    }
  | {
      [key: string]: never;
    };

const makeAddToBasket = (brandId: string): AddToBasket => {
  const driver: Http = makeDriver();

  const getBaskedId = () => {
    const cookie = getCookie('basket');
    let basketId;

    try {
      const cookieDecoded: CookieDecoded = cookie != null ? decode(cookie) : {};
      if (cookieDecoded.basketId != null) {
        basketId = cookieDecoded.basketId;
        return basketId;
      }
      return createBasket(brandId);
    } catch (e: unknown) {
      basketId = cookie;
      return basketId;
    }
  };

  return async ({ items }) => {
    const localeCode = getLanguageCookie();
    const basketId = await getBaskedId();

    return driver({
      url: `/api/basket/api/v2/baskets/${basketId}/items?localeCode=${localeCode}`,
      method: Method.POST,
      data: { items },
      headers: {
        'X-Tenant': brandId,
      },
    });
  };
};

export default makeAddToBasket;
